export enum GodsFilterDefaults {
  dbName = 'gods',
  url = '/filters/gods',
}
